<template>
    <div>
        <div>
            <a class="is-size-5 has-text-weight-bold" @click="updateMenu">&lt;&nbsp;Back</a>
            <span class="is-size-4 has-text-weight-bold has-text-primary" style="margin-left:40px;">Device {{deviceID}}</span>
        </div>
        <nav class="level info-tiles" style="margin-bottom:0;margin-top:0;">
            <div class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child">
                        <p class="heading is-size-5">Voltage</p>
                        <p class="title is-size-4 has-text-dark">Phase to Phase</p>
                    </article>
                </div>
            </div>
            <div v-for="sensor in phaseToPhase" class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">
                        <p class="title" style="font-size:1.5em;">
                            {{deviceMap[sensor]}}
                            <span v-if="devices[deviceID][sensor].val>80||devices[deviceID][sensor].val<20"
                                class="icon is-small has-text-warning">
                                &nbsp;<i class="fas fa-exclamation-triangle"></i>
                            </span>
                        </p>
                        <p>
                            <table style="table-layout:fixed;width:100%;">
                                <tr>
                                    <td rowspan="3" style="vertical-align : middle;font-size:1.5em;">
                                        {{devices[deviceID][sensor].val}}</td>
                                    <td>Avg: {{devices[deviceID][sensor].avg}}</td>
                                </tr>
                                <tr>
                                    <td>Min: {{devices[deviceID][sensor].min}}</td>
                                </tr>
                                <tr>
                                    <td>Max: {{devices[deviceID][sensor].max}}</td>
                                </tr>
                            </table>
                        </p>
                    </article>
                </div>
            </div>
        </nav>
        <nav class="level info-tiles" style="margin-top:0;margin-bottom:0;">
            <div class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child">
                        <p class="heading is-size-5">Current</p>
                        <!-- <p class="title">Current</p> -->
                    </article>
                </div>
            </div>
            <div v-for="sensor in currents" class="tile has-text-centered" style="flex-wrap: wrap;">
                <div class="tile is-parent">
                    <article class="tile is-child box">
                        <p class="title" style="font-size:1.5em;">
                            {{deviceMap[sensor]}}
                            <span v-if="devices[deviceID][sensor].val>80||devices[deviceID][sensor].val<20"
                                class="icon is-small has-text-warning">
                                &nbsp;<i class="fas fa-exclamation-triangle"></i>
                            </span>
                        </p>
                        <p>
                            <table style="table-layout:fixed;width:100%;">
                                <tr>
                                    <td rowspan="3" style="vertical-align : middle;font-size:1.5em;">
                                        {{devices[deviceID][sensor].val}}</td>
                                    <td>Avg: {{devices[deviceID][sensor].avg}}</td>
                                </tr>
                                <tr>
                                    <td>Min: {{devices[deviceID][sensor].min}}</td>
                                </tr>
                                <tr>
                                    <td>Max: {{devices[deviceID][sensor].max}}</td>
                                </tr>
                            </table>
                        </p>
                    </article>
                </div>
            </div>
        </nav>
        <nav class="level info-tiles" style="margin-top:0;margin-bottom:0;">
            <div class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child">
                        <!-- <p class="heading is-size-5">Other</p> -->
                        <!-- <p class="title">Current</p> -->
                    </article>
                </div>
            </div>
            <div v-for="sensor in simpleDevices" class="tile is-3 has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">
                        <p class="title" style="font-size:1.5em;">
                            {{deviceMap[sensor]}}
                            <span v-if="devices[deviceID][sensor].val>80||devices[deviceID][sensor].val<20"
                                class="icon is-small has-text-warning">
                                &nbsp;<i class="fas fa-exclamation-triangle"></i>
                            </span>
                        </p>
                        <p>
                            <table style="table-layout:fixed;width:100%;">
                                <tr>
                                    <td rowspan="3" style="vertical-align : middle;font-size:1.5em;">
                                        {{devices[deviceID][sensor].val}}</td>
                                    <td>Avg: {{devices[deviceID][sensor].avg}}</td>
                                </tr>
                                <tr>
                                    <td>Min: {{devices[deviceID][sensor].min}}</td>
                                </tr>
                                <tr>
                                    <td>Max: {{devices[deviceID][sensor].max}}</td>
                                </tr>
                            </table>
                        </p>
                    </article>
                </div>
            </div>
            <div class="tile is-3 has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child">
                        &nbsp;
                    </article>
                </div>
            </div>
        </nav>
        <nav class="level info-tiles" style="margin-top:0;margin-bottom:0;">
            <div class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">
                        <chart
                            :deviceID="deviceID"
                            :deviceMap="deviceMap"
                            :devices="devices"
                        ></chart>
                    </article>
                </div>
            </div>
        </nav>
        <nav class="level info-tiles" style="margin-top:0;margin-bottom:0;">
            <div class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">
                        <chart-max
                            :deviceID="deviceID"
                            :deviceMap="deviceMap"
                            :devices="devices"
                        ></chart-max>
                    </article>
                </div>
            </div>
            <div class="tile has-text-centered">
                <div class="tile is-parent">
                    <article class="tile is-child box">
                        <chart-min
                            :deviceID="deviceID"
                            :deviceMap="deviceMap"
                            :devices="devices"
                        ></chart-min>
                    </article>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import Chart from './Chart'
import ChartMax from './ChartMax'
import ChartMin from './ChartMin'
export default {
    components:{
        'chart':Chart,
        'chart-max':ChartMax,
        'chart-min':ChartMin
    },
    props:{
        deviceMap:Object,
        devices:Object,
        deviceID:Number
    },
    data() {
        return {
            phaseToPhase: ['RY', 'YB', 'BR'],
            simplePhase: ['VR', 'VY', 'VB'],
            currents: ['C1', 'C2', 'C3'],
            simpleDevices: ['VN', 'TM']
        }
    },
    methods: {
        updateMenu() {
            this.$emit('updateMenu', 'zone')
        }
    }
    }
</script>
<style scoped>
.info-tiles {
  margin: 1rem 0;
}

.info-tiles .subtitle {
  font-weight: 300;
  color: #8F99A3;
}

td{
  text-align: center !important;
}

th{
  text-align: center !important;
}
table{
    font-weight:100;
}
.tile .is-child{
  padding:10px;
}
.box {
  margin-top: 5rem;
  border-radius:0px;
  box-shadow: 0 2px 3px rgba(10,10,10,.05), 0 0 0 1px rgba(10,10,10,.05)
}
.has-text-grey {
  color: #3e5460 !important;
}
p {
  font-weight: 700;
}
</style>
